var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content intelligent-booking" },
    [
      _c(
        "div",
        { staticClass: "tabs-container" },
        [
          _c(
            "el-tabs",
            {
              staticStyle: { width: "100%" },
              attrs: { type: "card" },
              model: {
                value: _vm.activeTabName,
                callback: function($$v) {
                  _vm.activeTabName = $$v
                },
                expression: "activeTabName"
              }
            },
            [
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("CargoMsg.OCRRecognition"),
                    name: "tabOcr",
                    lazy: true
                  }
                },
                [
                  _c("tab-ocr", {
                    ref: "tabOcr",
                    attrs: {
                      "active-tab-name": _vm.activeTabName,
                      source: _vm.details.source,
                      "job-uuid": _vm.details.jobUuid,
                      "doc-uuid": _vm.details.docUuid
                    },
                    on: {
                      showDetails: _vm.handleShowDetails,
                      uploadEnd: _vm.uploadEndHandler
                    }
                  })
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("SeaExport.HangInTheAir"),
                    name: "tabPending",
                    lazy: true
                  }
                },
                [
                  _c("tab-pending", {
                    ref: "tabPending",
                    attrs: {
                      "active-tab-name": _vm.activeTabName,
                      source: _vm.details.source
                    },
                    on: {
                      supplementaryInformation: _vm.supplementaryInformation,
                      showDetails: _vm.handleShowDetails
                    }
                  })
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  ref: "tabFinished",
                  attrs: {
                    label: _vm.$t("SeaExport.Completed"),
                    name: "tabFinished",
                    lazy: true
                  }
                },
                [
                  _c("tab-finished", {
                    on: { showDetails: _vm.handleShowDetails }
                  })
                ],
                1
              ),
              _c(
                "el-tab-pane",
                {
                  attrs: {
                    label: _vm.$t("SeaExport.Dustbin"),
                    name: "tabTrash",
                    lazy: true
                  }
                },
                [_c("tab-trash")],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.details.visibleXhq
        ? _c("intelligent-booking-result-xhq", {
            attrs: {
              visible: _vm.details.visibleXhq,
              details: _vm.details.data,
              source: _vm.details.source
            },
            on: {
              close: _vm.handleCloseDetails,
              success: _vm.handleSaveSuccess
            }
          })
        : _vm._e(),
      _vm.details.visibleMnh
        ? _c("intelligent-booking-result", {
            attrs: {
              visible: _vm.details.visibleMnh,
              details: _vm.details.data,
              source: _vm.details.source
            },
            on: {
              close: _vm.handleCloseDetails,
              success: _vm.handleSaveSuccess
            }
          })
        : _vm._e(),
      _vm.details.visibleBy
        ? _c("intelligent-booking-result-by", {
            attrs: {
              visible: _vm.details.visibleBy,
              details: _vm.details.data,
              source: _vm.details.source
            },
            on: {
              close: _vm.handleCloseDetails,
              success: _vm.handleSaveSuccess
            }
          })
        : _vm._e(),
      _vm.details.visibleBillBy
        ? _c("intelligent-bill-result-by", {
            attrs: {
              visible: _vm.details.visibleBillBy,
              details: _vm.details.data,
              source: _vm.details.source
            },
            on: {
              close: _vm.handleCloseDetails,
              success: _vm.handleSaveSuccess
            }
          })
        : _vm._e(),
      _vm.details.visibleCwmi
        ? _c("intelligent-booking-result-cwmi", {
            attrs: {
              visible: _vm.details.visibleCwmi,
              details: _vm.details.data,
              source: _vm.details.source
            },
            on: {
              close: _vm.handleCloseDetails,
              success: _vm.handleSaveSuccess
            }
          })
        : _vm._e(),
      _vm.details.visibleMulti
        ? _c("intelligent-booking-result-multi", {
            attrs: {
              visible: _vm.details.visibleMulti,
              "detail-list": _vm.details.dataList,
              source: _vm.details.source
            },
            on: {
              close: _vm.handleCloseDetails,
              success: _vm.handleSaveSuccessMulti,
              copyIntelligentDocument: _vm.copyIntelligentDocumentFunc
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }